module.exports = __webpack_public_path__ + "static/media/Redux-Saga-Logo,webp.d5960a9f.png";